module.exports = __webpack_public_path__ + "static/img/service_bg_h5_zh.d9c0320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_bg_h5_zh.png
// module id = Uj98
// module chunks = 34